import { useQuery, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { useFetchContactEngagementOptions } from './useFetchContactEngagementOptions';
export const CAMPAIGN_CONTACT_ENGAGEMENT_FIELD_NAME = 'campaignContactEngagement';
async function getCampaignContactEngagement({
  campaignId,
  contactId
}) {
  // Get user-defined association definitions between campaigns and contacts
  const userDefinedAssociations = await http.get('associations/v1/definitions/0-35', {
    query: {
      includeFATypes: 'true'
    }
  }).then(res => {
    return (res || []).filter(definition => definition.category === 'USER_DEFINED' && definition.toObjectTypeId === '0-1');
  });
  if (userDefinedAssociations.length === 0) {
    return null;
  }

  // Then, get the actual associations between this campaign and contact
  const associationsResponse = await http.post('associations/v1/associations/first-page-batch', {
    data: {
      objectIdsByType: {
        CAMPAIGN: [campaignId]
      },
      associationTypeIdsByCategory: {
        USER_DEFINED: userDefinedAssociations.map(def => def.id)
      }
    }
  });
  const contactAssociation = associationsResponse.find(assoc => assoc.results.results.includes(parseInt(contactId, 10)));
  const associationTypeId = contactAssociation === null || contactAssociation === void 0 ? void 0 : contactAssociation.associationTypeId;

  // Find the user-defined association
  const userDefinedAssociation = userDefinedAssociations.find(assoc => assoc.id === associationTypeId);
  return userDefinedAssociation ? {
    label: userDefinedAssociation.label || userDefinedAssociation.name
  } : null;
}
const GET_CAMPAIGN_CONTACT_ENGAGEMENT = registerQuery({
  fieldName: CAMPAIGN_CONTACT_ENGAGEMENT_FIELD_NAME,
  args: ['campaignId', 'contactId'],
  fetcher: getCampaignContactEngagement
});
export function useFetchCampaignContactEngagement({
  campaignId,
  contactId,
  skip = false
}) {
  var _engagementOptions$fi;
  // Get engagement options to map label to value
  const {
    options: engagementOptions
  } = useFetchContactEngagementOptions();
  const {
    data,
    loading,
    error
  } = useQuery(GET_CAMPAIGN_CONTACT_ENGAGEMENT, {
    variables: {
      campaignId: campaignId,
      contactId: contactId
    },
    skip: !campaignId || !contactId || skip
  });
  const engagement = data === null || data === void 0 ? void 0 : data[CAMPAIGN_CONTACT_ENGAGEMENT_FIELD_NAME];
  const engagementLabel = engagement === null || engagement === void 0 ? void 0 : engagement.label;

  // Find the engagement value from the available options
  const engagementValue = engagementLabel && engagementOptions.length > 0 ? (_engagementOptions$fi = engagementOptions.find(option => option.text === engagementLabel)) === null || _engagementOptions$fi === void 0 ? void 0 : _engagementOptions$fi.value.toString() : undefined;
  return {
    engagementLabel,
    engagementValue,
    loading,
    error
  };
}